import React, { FC, memo } from 'react';

import { TEXTS } from 'application/pages/PointsPage/renderer/texts';
import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { useBillingRepositoryInjector } from 'application/providers/DIContainerProvider';
import { useAccountCompanyId } from 'application/hooks';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import { PaymentKind } from '@shared/api/graphql/generated';

import styles from './index.module.scss';

const PointCreateConfirmModal: FC<ModalProps[ModalTypes.POINT_CREATE_CONFIRM]> = ({ cost, onSubmit, close }) => {
  const companyId = useAccountCompanyId();
  const { watchBillingInfo } = useBillingRepositoryInjector();
  const { selectedPaymentKind } = watchBillingInfo(companyId);

  const handleSubmit = () => {
    onSubmit();
    close();
  };

  return (
    <ModalScreen
      title={TEXTS.POINT_CREATE_CONFIRM_MODAL_TITLE}
      hideCloseButton
      onClose={close}
      actionButtons={[
        <Button
          key="button_create_point_confirm_submit"
          elementId="button_create_point_confirm_submit"
          type={ButtonType.PRIMARY}
          onClick={handleSubmit}>
          {TEXTS.POINT_CREATE_CONFIRM_MODAL_BUTTON_SUBMIT(cost)}
        </Button>,
        <Button
          key="button_create_point_confirm_cancel"
          elementId="button_create_point_confirm_cancel"
          type={ButtonType.SECONDARY}
          onClick={() => close()}>
          {TEXTS.POINT_CREATE_CONFIRM_MODAL_BUTTON_CANCEL}
        </Button>,
      ]}>
      <div className={styles.description}>
        {selectedPaymentKind === PaymentKind.Sbbol
          ? TEXTS.POINT_CREATE_CONFIRM_MODAL_DESCRIPTION_SBBOL
          : TEXTS.POINT_CREATE_CONFIRM_MODAL_DESCRIPTION}
      </div>
    </ModalScreen>
  );
};

export default memo(PointCreateConfirmModal);
